<div class="modal-header">
  <h4 class="modal-title pull-left">Report Engaged</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <h5 style="text-align: center;">System has received Information about Report was Engaged by Client</h5>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Ok</button>
</div>
